import { config } from '@fortawesome/fontawesome-svg-core'
import { GatsbyBrowser } from 'gatsby'

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  config.autoAddCss = false
}
